// A tela pedida antes de entrar (o link "Assinar" do site leva a
// app.hsafrota.com.br/#/assinatura): quem ainda não entrou passa pela
// entrada e, depois de entrar (e de cadastrar a empresa, se for nova), cai
// nela. Fica guardada no aparelho por 1 hora (o link do e-mail abre outra aba).
const CHAVE = 'maxcargo-depois-de-entrar';
const VALIDADE_MS = 60 * 60 * 1000;
// Só as telas que o site pede
const PERMITIDAS = new Set(['/assinatura']);

const armazenamentoPadrao = () => {
  try {
    return globalThis.localStorage ?? null;
  } catch {
    return null;
  }
};

export function guardarPedido(caminho, { armazenamento = armazenamentoPadrao(), agora = Date.now() } = {}) {
  if (!PERMITIDAS.has(caminho) || !armazenamento) return false;
  try {
    armazenamento.setItem(CHAVE, JSON.stringify({ caminho, ate: agora + VALIDADE_MS }));
    return true;
  } catch {
    return false;
  }
}

// A tela pedida (uma vez só: depois de lida, sai do aparelho), ou null.
export function tirarPedido({ armazenamento = armazenamentoPadrao(), agora = Date.now() } = {}) {
  if (!armazenamento) return null;
  try {
    const texto = armazenamento.getItem(CHAVE);
    if (!texto) return null;
    armazenamento.removeItem(CHAVE);
    const { caminho, ate } = JSON.parse(texto);
    return PERMITIDAS.has(caminho) && Number(ate) > agora ? caminho : null;
  } catch {
    return null;
  }
}
